import React from "react";
import { Dropdown, Button } from "@douyinfe/semi-ui";
import { IconMore } from "@douyinfe/semi-icons";
import {
  JobHistoryModel,
  FileIdDictModel,
  ProteinBinderSummaryModel,
  DockingFileIdDictModel,
  DockingSummaryModel,
} from "@services/home/model/home.model";
import { useTranslation } from "react-i18next";
import { JobStatusEnum, JobTypeEnum } from "@services/home/enum/home.enum";
import { getJobDetailApi, downloadFileApi } from "@services/home/home.api";
import { downloadZIP } from "@utils/file.util";
import { getSummaryCsvApi } from "@services/task/task.api";
import Papa from "papaparse";

interface Prop {
  jobItem: JobHistoryModel;
  job_type: JobTypeEnum;
  rename: (p: JobHistoryModel) => void;
  refresh: () => void;
  rerun: (p: JobHistoryModel) => void;
  deleteItem: (p: JobHistoryModel) => void;
}

const JobOptButton: React.FC<Prop> = ({
  jobItem,
  job_type,
  rename,
  refresh,
  rerun,
  deleteItem,
}) => {
  const { t, i18n } = useTranslation();

  function onRename() {
    rename(jobItem);
  }

  async function getSummaryCsv(jid: string) {
    try {
      const data = await getJobDetailApi(jid);
      const res = await getSummaryCsvApi([data.summary_id]);
      const result = Papa.parse<Record<string, any>>(res, {
        dynamicTyping: true,
        skipEmptyLines: true,
        header: true,
      });

      let fileIds: string[] = [];

      if (job_type === JobTypeEnum.AbAgDocking) {
        const list = result.data.map((item) => {
          const o = { ...item };
          o.file_id_dict = item.file_id_dict
            ? (JSON.parse(
                item.file_id_dict as string
              ) as DockingFileIdDictModel)
            : null;

          return o as DockingSummaryModel;
        });

        const ids = list.map((item) => {
          return item.file_id_dict.cif;
        });

        fileIds = ids;
      } else {
        const list = result.data.map((item) => {
          const o = { ...item };
          o.file_id_dict = item.file_id_dict
            ? (JSON.parse(item.file_id_dict as string) as FileIdDictModel)
            : null;
          return o as ProteinBinderSummaryModel;
        });

        if (list.length > 0) {
          const pdbs = list[0].file_id_dict.packed_pdb_list;

          const ids = pdbs.map((item) => {
            return item.pdb_file;
          });
          fileIds = ids;
        }
      }

      const fileContent = await downloadFileApi(fileIds, "", "blob");

      if (fileContent instanceof Blob) {
        downloadZIP(fileContent, data.name);
      }
    } catch (e) {
      console.error("getSummaryCsv-->", e);
    }
  }

  function onDownload(item: JobHistoryModel) {
    if (item.status === JobStatusEnum.Finished) {
      getSummaryCsv(item.id);
    }
  }

  function onDelete(item: JobHistoryModel) {
    deleteItem(item);
  }

  function onRerun() {
    rerun(jobItem);
  }

  return (
    <Dropdown
      render={
        <Dropdown.Menu>
          <Dropdown.Item onClick={onRename}>
            {t("gadget.operation.rename")}
          </Dropdown.Item>
          {jobItem.status === JobStatusEnum.Finished && (
            <Dropdown.Item onClick={() => onDownload(jobItem)}>
              {t("gadget.operation.download")}
            </Dropdown.Item>
          )}

          <Dropdown.Item onClick={onRerun}>
            {t("gadget.operation.rerun")}
          </Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => onDelete(jobItem)}>
            {t("gadget.operation.delete")}
          </Dropdown.Item>
        </Dropdown.Menu>
      }
    >
      <Button
        theme="borderless"
        style={{
          marginLeft: "auto",
          height: "16px",
          padding: 0,
          marginTop: "-8px",
        }}
        icon={
          <IconMore
            style={{
              color: "var(--semi-color-text-2)",
            }}
          />
        }
        size="small"
      />
    </Dropdown>
  );
};

export default JobOptButton;
